import { useQuery } from 'react-query';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export interface CharitableGivingGoalDTO {
  id: string;
  name: string;
  donationStartYear: number;
  donationEndYear: number;
}

const fetchGoals = async (clientId: number): Promise<CharitableGivingGoalDTO[]> => {
  return authFetch(urlWithParams('/Consumer/CharitableGivingWorkflow/Goals', { clientId }));
};

export const useCharitableGivingGoalsQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.goals(clientId),

    () => fetchGoals(clientId),

    {
      cacheTime: 0,
    },
  );
};
